// extracted by mini-css-extract-plugin
export var badge = "_io-2";
export var detailsPanel = "_io-0";
export var resultRow = "_io-1";